import React from 'react'

import type { MenuSearchResponse } from '@library/api-menu-experience'
import { MenuSearchContent } from '@library/menu-page'
import type { MenuSearchContentProps } from '@library/menu-page'

import { RelevantRecipesSkeleton } from '../LoadingSkeleton/RelevantRecipesSkeleton'
import { SearchError } from '../SearchError/SearchError'

type MenuExperienceSearchResultsProps = Omit<MenuSearchContentProps, 'response'> & {
  error?: unknown
  isLoading: boolean
  response?: MenuSearchResponse
  retry: () => void
}

export const MenuExperienceSearchResults = ({
  canAddRecipes,
  error,
  getIsInBasket,
  getQuantity,
  isAuthenticated,
  isLoading,
  onAddRecipe,
  onBlockedAddAttempt,
  onCategoryClick,
  onRecipeClick,
  onRemoveRecipe,
  reachedLimit,
  renderFlexPortionControl,
  response,
  retry,
}: MenuExperienceSearchResultsProps) => {
  if (error) {
    return <SearchError onRetry={retry} />
  }

  if (response) {
    return (
      <MenuSearchContent
        canAddRecipes={canAddRecipes}
        getIsInBasket={getIsInBasket}
        getQuantity={getQuantity}
        isAuthenticated={isAuthenticated}
        onAddRecipe={onAddRecipe}
        onBlockedAddAttempt={onBlockedAddAttempt}
        onCategoryClick={onCategoryClick}
        onRecipeClick={onRecipeClick}
        onRemoveRecipe={onRemoveRecipe}
        reachedLimit={reachedLimit}
        renderFlexPortionControl={renderFlexPortionControl}
        response={response}
      />
    )
  }

  return isLoading ? <RelevantRecipesSkeleton /> : null
}
